import React from 'react';
import '../styles/About.css';

import html from '../images/htmlcssjs.png';
import node_svg from '../images/node.svg';
import react_svg from '../images/react.svg';

export default function About() {
  return (
    <div className="about" id="about">
      <div className="tech">
        <h4 className="tech-head">Tech That I know</h4>
        <div className="tech-logos">
          <img src={html} alt="" width="40%" />
          <img src={node_svg} alt="" width="15%" />
          <img src={react_svg} alt="" width="15%" />
        </div>
      </div>
      <div className="about-me">
        <h4 className="about-head">About me</h4>
        <div className="about-details">
          Hi, Srivatsan here. A full stack developer with a good sense of UI/UX
          designs. A tech enthusiast. Keen on learning new stuff everyday.
          Currently a final year student at NITK.
        </div>
      </div>
    </div>
  );
}
